import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { TicketStatus } from "@/api/tickets/tickets";

export interface Status {
  key: TicketStatus;
  display_name: string;
}

export function StatusHandbook(props: AutocompleteProps<Status>) {
  const items: Status[] = [
    { key: "open", display_name: "Открыт" },
    { key: "in_progress", display_name: "В работе" },
    { key: "closed", display_name: "Закрыт" },
  ];

  return (
    <Autocomplete
      defaultItems={items}
      label="Статус"
      placeholder="Выберите статус"
      variant="bordered"
      {...props}
    >
      {(item) => (
        <AutocompleteItem key={item.key}>{item.display_name}</AutocompleteItem>
      )}
    </Autocomplete>
  );
}
